// src/api/notificationApi.ts
import { ENV } from '../../config/runtimeEnv';
import type { Notification } from '../../types/communications/NotificationTypes';
import { createServiceClient } from '../../lib/http/client';
export const API_BASE_URL = ENV.VITE_NOTIFICATION_BASE_URL;



// Create axios instance with default config
const createApiInstance = () => {
	return createServiceClient({
		baseURL: API_BASE_URL,
		headers: {
			'Content-Type': 'application/json',
		},
	});
};

export const fetchNotifications = async (userId: string): Promise<Notification[]> => {
	try {
		const api = createApiInstance();
		const response = await api.get<Notification[]>('/notifications', {
			params: { user_id: userId },
		});
		return response.data;
	} catch (error) {
		console.error('Error fetching notifications:', error);
		throw error;
	}
};

export const markAsRead = async (id: string): Promise<any> => {
	try {
		const api = createApiInstance();
		const response = await api.patch(`/notifications/${id}`, {
			read_status: true,
			status: "seen"
		});
		return response.data;
	} catch (error) {
		console.error('Error marking notification as read:', error);
		throw error;
	}
};

export const updateStatus = async (id: string, status: string): Promise<any> => {
	try {
		const api = createApiInstance();
		const response = await api.put('/notifications/status', {
			id,
			status
		});
		return response.data;
	} catch (error) {
		console.error('Error updating notification status:', error);
		throw error;
	}
};

export const deleteNotification = async (id: string): Promise<any> => {
	try {
		const api = createApiInstance();
		const response = await api.delete(`/notifications/${id}`);
		return response.data;
	} catch (error) {
		console.error('Error deleting notification:', error);
		throw error;
	}
};

export const bulkDeleteNotifications = async (ids: string[]): Promise<any> => {
	try {
		const api = createApiInstance();
		const response = await api.post('/notifications/bulk-delete', { ids });
		return response.data;
	} catch (error) {
		console.error('Error bulk deleting notifications:', error);
		throw error;
	}
};

export const deleteAllNotifications = async (userId: string): Promise<any> => {
	try {
		const api = createApiInstance();
		const response = await api.delete('/notifications/delete-all', {
			data: { user_id: userId },
		});
		return response.data;
	} catch (error) {
		console.error('Error deleting all notifications:', error);
		throw error;
	}
};

export const markAllNotificationsAsRead = async (userId: string): Promise<any> => {
	try {
		const api = createApiInstance();
		const response = await api.post('/notifications/mark-all-read', {
			user_id: userId,
		});
		return response.data;
	} catch (error) {
		console.error('Error marking all notifications as read:', error);
		throw error;
	}
};
